<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
   <div>
       <Breadcrumbs main="User" title="User Details" />

      <div class="container-fluid">
         <div class="row">
            <div class="col-sm-12">

               <div class="card">
                  <div class="card-body">
                     <div class="row">
                        <div class="col-md-10 d-flex">
                           <h5>User Details</h5>
                        </div>
                        <div class="col-md-2">
                           <h6 v-if="user.status==0">
                              <span>Status: </span>
                              <span class="text-danger">Blocked</span><br>
                              <span>Blocked by: {{user.blocked_by}}</span>
                           </h6>
                           <h6 v-else-if="user.status==1">
                              <span>Status: </span>
                              <span class="text-success">Active</span>
                           </h6>
                        </div>
                        
                     </div><br>
                     <div class="details">  
                        <div class="row">
                           <div class="col md-6 lg-2 "> 

                              <img v-if="user.image" :src="$image_url + user.image" alt="Image not found" class="img-fluid avatar-60 rounded-small">
                              <img v-else :src="$image_url + user.default_image" alt="Image not found" class="img-fluid avatar-120 rounded-small">
                           </div> 

                           <div class="col md-6 lg-4">
                              <h6>Name:</h6>
                              <p>{{user.name}}</p>
                              <h6>Contact</h6>
                              <p class="mb-0">{{user.countrycode}} {{user.phone_number}}</p>
                              <p>{{user.email}}</p>
                           </div> 

                           <div class="col md-6 lg-3 ">
                              <h6>Followers:</h6>
                              <p>{{user.followers}}</p>
                              <h6>Following</h6>
                              <p>{{user.following}}</p>
                           </div> 

                           <div class="col md-6 lg-3 ">
                              <h6>Registered on:</h6>
                              <p>{{$filters.formatDateTime(user.created_at)}}</p>
                              <h6>Last updated on:</h6>
                              <p>{{$filters.formatDateTime(user.updated_at)}}</p>
                           </div>
                        </div>
                     </div>
                     
                     
                  </div>
         
               </div>

               <div class="card">
                  <div class="card-body">
                     <div class="row">
                        <h5>Product Ads</h5>
                     </div><br>
                     
                     <div class="details">  
                        <div class="row"> 
                           <div class="col md-6 lg-2">
                              <h6>Total:</h6>
                              <p>{{user.products}}</p>                              
                           </div>    

                           <div class="col md-6 lg-2">
                              <h6>Pending:</h6>
                              <p>{{user.pending_product}}</p>                              
                           </div> 

                           <div class="col md-6 lg-2">
                              <h6>Live:</h6>
                              <p>{{user.live_product}}</p>                              
                           </div>

                           <div class="col md-6 lg-2">
                              <h6>Deactivated:</h6>
                              <p>{{user.deactivated_product}}</p>
                           </div>

                           <div class="col md-6 lg-2">
                              <h6>Rejected:</h6>
                              <p>{{user.rejected_product}}</p>
                           </div>

                           <div class="col md-6 lg-2">
                              <h6>Sold:</h6>
                              <p>{{user.sold_product}}</p>
                           </div>

                        </div>
                     </div>
                  </div>
               </div>

              

               <div class="card">
                  <div class="card-body">
                     <div class="row">
                        <h5>Location</h5>
                     </div><br>
                     
                     <div class="details">  
                        <div class="row">                          

                           <div class="col md-12 lg-12">
                              <p>{{user.location}}</p>                              
                           </div> 
                        </div>
                        <div  class="col md-12 lg-12">
                              <!-- <GmapMap v-if="user.location"
                              :center="center"
                              :zoom="18"
                              map-style-id="roadmap"
                              :options="mapOptions"
                              style="width: 100%; height: 300px"
                              ref="mapRef">                              
                                 <GmapMarker
                                    :position="marker.position"
                                    :clickable="false"
                                    :draggable="false"                                    
                                 />
                           </GmapMap>         -->
                           <div class="gmap_canvas">
                           <iframe class="gmap_iframe" width="100%" height="300px" frameborder="0" scrolling="no" marginheight="0"
                                    marginwidth="0" :src="getMapUrl()"></iframe >
                           </div>
                        </div>

                     </div>
                  </div>
               </div>
               
            </div>
         </div>
      </div>


     
  </div>
</template>


<script>
export default {
   name:'UserDetails',
   data() {
      return {
         user: {},         
         
         user_status: {
            id: "",
            status: ""
         },  

         marker: { position: { lat: 10, lng: 10 } },
         center: { lat: 10, lng: 10 },

         mapOptions: {
            disableDefaultUI: true,
         },       
         
         token: '',
         errors: {}
      };
   },
   mounted () {
      
   },

   created() {
      this.fetchUser();
   },

   methods: {
      
      fetchUser() {
          let url = '/api/admin/users/show?user_id=' + this.$route.params.id ;
            
         this.getToken();
         this.$axios
            .get(url, {headers: {Authorization: 'Bearer ' + this.token,}})
            .then(res => {
               var responseData = res.data.data;               
               this.user = responseData; 

               this.marker.position.lat = parseFloat(this.user.latitude);
               this.marker.position.lng = parseFloat(this.user.longitude);

               this.center.lat = parseFloat(this.user.latitude);
               this.center.lng = parseFloat(this.user.longitude);
               console.log(this.user);             
            })
            .catch(err => console.log(err));
      },   

      getMapUrl() {
            return `https://maps.google.com/maps?q=${this.center.lat},${this.center.lng}&z=15&output=embed`;
      },

      getToken() {
         if (localStorage.getItem('slo_admin')) {
            var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                     
            if(slo_admin.token) {

               this.token = slo_admin.token;
               this.user = slo_admin;

            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "Login" });
            }

         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "Login" });
         }
      },

      
   }   
}
</script>